import React from "react";
import { ActionWithRulesAndAddersProps } from "react-querybuilder";
import { Button } from "@chakra-ui/react";
import { CirclePlusIcon } from "modules/icons";
import colors from "app/colors";

const QueryAddRuleAction: React.FC<ActionWithRulesAndAddersProps> = ({
  handleOnClick,
  className,
}) => (
  <Button
    className={className}
    onClick={handleOnClick}
    color={colors.blue}
    fontSize={12}
    fontWeight={600}
    leftIcon={<CirclePlusIcon fill={colors.blue} boxSize={4} />}
    variant="hover"
    size="xxs"
    iconSpacing={1}
  >
    Add Rule
  </Button>
);

export default QueryAddRuleAction;
